/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Alerts/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import Alert from './Alert/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2CalendarNote from 'DesignSystem/Svgs/Tysiav2CalendarNote/index'
import Tysiav2ClockFilled from 'DesignSystem/Svgs/Tysiav2ClockFilled/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Alerts({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/Calendar/Content/Content/Alerts/Content/Content/Alerts"
  
}) {
let alertsNotesValueData = fromData.useDataFormat({ viewPath,
context: 'alerts',
path: 'notes',
format: fromFormat.isNotEmptyList,
})
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtColorsBlue500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.blue.500'
        })
let constantData = 'Schedule Notes'
let alertsNotesValueData1 = fromData.useDataValue({ viewPath,
context: 'alerts',
path: 'notes',
})
let aggregateData = fromHelpers.getHeading(constantData, alertsNotesValueData1)
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let alertsNotesValueData2 = fromData.useDataValue({ viewPath,
context: 'alerts',
path: 'notes',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let alertsBlockedTimesValueData = fromData.useDataFormat({ viewPath,
context: 'alerts',
path: 'blocked_times',
format: fromFormat.isNotEmptyList,
})
let constantData1 = 'Blocked Time'
let alertsBlockedTimesValueData1 = fromData.useDataValue({ viewPath,
context: 'alerts',
path: 'blocked_times',
})
let aggregateData1 = fromHelpers.getHeading(constantData1, alertsBlockedTimesValueData1)
let alertsBlockedTimesValueData2 = fromData.useDataValue({ viewPath,
context: 'alerts',
path: 'blocked_times',
})
  return (<React.Fragment
>
<fromFlow.When is={alertsNotesValueData}>
<div
  data-testid="Alerts.Vertical"
  data-view-path={viewPath}
 style={{'--g-1-2jOCQC': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Alerts.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Tysiav2CalendarNote
  viewPath={`${viewPath}/Tysiav2CalendarNote`}
 fill2={dtColorsBlue500}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft={dtSpaceXs}
 weight="semibold"
 data="'Schedule Notes'"
 data="alerts.notes"
 aggregate="helpers.js getHeading"
 text={aggregateData}
/>
</div>
<div
  data-testid="Alerts.List"
  data-view-path={viewPath}
 style={{'--mt-2-2jOCQC': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.List}`}
>
{Array.isArray(alertsNotesValueData2) && alertsNotesValueData2.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="alert"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/Alert(${item?.id ?? item?._id ?? index})`}
      >
<Alert
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/Alert(${item?.id ?? item?._id ?? index})`}
/>
</ListItem>
)}
</div>
</div>
</fromFlow.When>
<fromFlow.When is={alertsBlockedTimesValueData}>
<div
  data-testid="Alerts.Vertical:1"
  data-view-path={viewPath}
 style={{'--g-1-2jOCQC': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="Alerts.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<Tysiav2ClockFilled
  viewPath={`${viewPath}/Tysiav2ClockFilled`}
 fill2="#8562C7"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft={dtSpaceXs}
 weight="semibold"
 data="'Blocked Time'"
 data="alerts.blocked_times"
 aggregate="helpers.js getHeading"
 text={aggregateData1}
/>
</div>
<div
  data-testid="Alerts.List:1"
  data-view-path={viewPath}
 style={{'--mt-2-2jOCQC': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.List1}`}
>
{Array.isArray(alertsBlockedTimesValueData2) && alertsBlockedTimesValueData2.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="alert"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/Alert(${item?.id ?? item?._id ?? index})`}
      >
<Alert
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/Alert(${item?.id ?? item?._id ?? index})`}
/>
</ListItem>
)}
</div>
</div>
</fromFlow.When>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }